<div class="container-fluid">
  <div class="card border-0 no-shadow mb-3 p-0">
    <div class="card-header text-white">Samples Received</div>
    <ngx-spinner
      bdColor="rgba(51, 51, 51, 0.8)"
      size="large"
      color="#fff"
      type="ball-spin-clockwise"
      [fullScreen]="true"
    >
    </ngx-spinner>
    <div class="card-body p-4">
      <div class="mt-2 d-flex "  style="justify-content: right;">
        <!-- <div class="float-left">
          <button class="btn btn-lg mr-2 sample-qr-button" routerLink="/lab-analyst/scan-qr">
            Scan Sample QR
          </button>
        </div> -->
        <div >
          <ul class="nav nav-tabs">
            <li
              class="nav-item p-2 text-center"
              *ngFor="let tab of tabs"
              (click)="onChange(tab)"
              [ngClass]="{
                'active-tab': tab.isSelected,
                'inactive-tab': !tab.isSelected
              }"
              style="width: 170px; float: left"
            >
              {{ tab.heading }}
            </li>
          </ul>
        </div>
      </div>
      <div class="mt-2 d-flex">
        <div class="float-left">
          <div class="input-group">
            <input
              type="search"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="searchTexts"
              aria-label="Search"
              aria-describedby="search-addon"
            />
            <button type="button" class="btn">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="container table-responsive mt-3 p-0">
        <table class="table table-striped">
          <thead class="thead">
            <tr>
              <th scope="col">
                <span>S.No.</span>
              </th>
              <th
                scope="col"
                [appSort]="orgList"
                data-order="desc"
                data-name="trayId"
              >
                <span>Tray</span>&nbsp;<span
                  ><img src="../../../../../../assets/sort-icon.png"
                /></span>
              </th>
              <th
                scope="col"
                [appSort]="orgList"
                data-order="desc"
                data-name="noOfSamples"
              >
                <span>No of Samples</span>&nbsp;<span
                  ><img src="../../../../../../assets/sort-icon.png"
                /></span>
              </th>
              <th
                scope="col"
                [appSort]="orgList"
                data-order="desc"
                data-name="updatedTimeStamp | date: 'dd-MMM-yy'"
              >
                <span>Date of Testing</span>&nbsp;<span
                  ><img src="../../../../../../assets/sort-icon.png"
                /></span>
              </th>
              <th
                scope="col"
                [appSort]="orgList"
                data-order="desc"
                data-name="samplingStatus"
                *ngIf="currentTab === 'Pending'"
              >
                <span>Status</span>&nbsp;<span
                  ><img src="../../../../../../assets/sort-icon.png"
                /></span>
              </th>

              <th scope="col">
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let org of orgList | filter: searchTexts | paginate: config;
                let i = index
              "
            >
              <td class="first-td">{{ i + 1 }}</td>
              <td class="middle-td">{{ org.trayId }}</td>
              <td class="middle-td">{{ org?.noOfSamples }}</td>
              <td class="middle-td">{{ org.lab_analyst_date }}</td>
              <td class="middle-td" *ngIf="currentTab === 'Pending'">
                {{ org.samplingStatus }}
              </td>
              <td class="last-td">
                <p class="d-flex m-0 justify-content-center">
                  <a
                    (click)="goToViewChallan(org)"
                    class="button button-small view-button pt-0 "
                  >
                    {{
                      org.samplingStatus == "Testing in Progress"
                        ? "View"
                        : "View Results"
                    }}
                  </a>
                  <a
                    (click)="goToUploadResult(org)"
                    class="button button-small view-button pt-0 border-left-color"
                    *ngIf="org.samplingStatus === 'Testing in Progress'"
                  >
                    Upload Result
                  </a>
                  <a
                    class="button button-small view-button pt-0 border-left-color"
                 
                    *ngIf="org.samplingStatus === 'Testing in Progress'"
                    (click)="updateStatus(org)"
                  >
                    Submit
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-end">
          <pagination-controls
            (pageChange)="pageChange($event)"
            (pageBoundsCorrection)="pageChange($event)"
            maxSize="6"
            directionLinks="true"
            autoHide="false"
            responsive="true"
            previousLabel="Previous"
            nextLabel="Next"
            screenReaderPaginationLabel="Pagination"
            screenReaderPageLabel="page"
            screenReaderCurrentLabel="You're on page"
          >
          </pagination-controls>
        </div>
      </div>

      <div></div>
    </div>
  </div>
</div>
